/**
 * Plugin Vue pour la gestion globale du CSRF
 */

import { getCSRFToken, hasCSRFToken, addCSRFTokenToHeaders } from '../utils/csrf.js'

export default {
    install(app) {
        // Ajouter les utilitaires CSRF à l'instance Vue
        app.config.globalProperties.$csrf = {
            getToken: getCSRFToken,
            hasToken: hasCSRFToken,
            addToHeaders: addCSRFTokenToHeaders
        }
        
        // Ajouter une propriété réactive pour l'état du token CSRF
        app.config.globalProperties.$csrfState = {
            hasToken: hasCSRFToken(),
            token: getCSRFToken()
        }
        
        // Méthode pour rafraîchir l'état du token CSRF
        app.config.globalProperties.$refreshCSRF = function() {
            this.$csrfState.hasToken = hasCSRFToken()
            this.$csrfState.token = getCSRFToken()
        }
        
        // Mixin pour ajouter les propriétés CSRF à tous les composants
        app.mixin({
            computed: {
                $csrfAvailable() {
                    return this.$csrfState.hasToken
                },
                $csrfToken() {
                    return this.$csrfState.token
                }
            },
            methods: {
                $refreshCSRFState() {
                    this.$refreshCSRF()
                }
            }
        })
    }
} 